export default __webpack_public_path__ + "static/aneta_alingua-scaled-23f74658a94413b1ff43f933e9a1d271.jpg";